import debounce from 'lodash.debounce'
import BaseNodeChildren from 'publisher/components/ChildrenEntities'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { pageSelectors, usePage } from 'publisher/store'
import React, { useRef, useState } from 'react'
import { CommonCarousel } from 'src/shared/components/carousel'
import {
  CarouselInterface,
  CarouselItemInterface,
} from 'src/shared/entities/carousel/carousel.schema'
import CarouselSlide from './carousel-slide'

type CarouselProps = {
  entity: CarouselInterface
}

export const Carousel = ({ entity }: CarouselProps) => {
  const entities: CarouselItemInterface[] = usePage(page =>
    pageSelectors.getChildrenEntities(page, entity.childIds),
  )
  const [needScroll, setNeedScroll] = useState(false)
  const [activeSlideIndex, setActiveSlideIndex] = useState(0)
  const carouselRef = useRef<HTMLDivElement>(null)

  const updateActiveSlideIndex = (index: number) => {
    setActiveSlideIndex(prevIndex => {
      setNeedScroll(prevIndex !== index)
      return index
    })
  }

  const updateActive = debounce(updateActiveSlideIndex, 300)

  return (
    <StyleWrapper
      appearance={entity.appearance}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
    >
      <CommonCarousel
        arrowsColor={entity.arrowsColor}
        controlsColor={entity.controlsColor}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
        totalItems={entity.childIds.length}
        htmlAttrId={entity.htmlAttrId}
        showArrows={entity.showArrows}
        mobileShowArrows={entity.mobileShowArrows}
        switchActiveSlideNumber={updateActive}
        activeSlideIndex={activeSlideIndex}
        carouselRef={carouselRef}
      >
        {entities.map((carouselSlideEntity, index) => (
          <CarouselSlide
            key={carouselSlideEntity.id}
            active={index === activeSlideIndex}
            setActive={() => updateActive(index)}
            alignSelf={entity.verticalAlignment}
            mobileAlignSelf={entity.mobileVerticalAlignment}
            carouselRef={carouselRef}
            needScroll={needScroll}
          >
            <BaseNodeChildren childIds={carouselSlideEntity.childIds} />
          </CarouselSlide>
        ))}
      </CommonCarousel>
    </StyleWrapper>
  )
}
